<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Products'
    },

    extends: TableView,

    data() {
        const { id: shopId } = this.$route.params;

        return {
            shop: {},
            shopId
        };
    },

    computed: {
        title() {
            return `${this.shop.name}'s Products`;
        },

        breadcrumbs() {
            return [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Shops',
                    to: '/shops'
                },
                {
                    text: this.shop.name,
                    to: `/shops/${this.shop.id}/edit`
                },
                {
                    text: 'Products',
                    active: true
                }
            ];
        },

        labels() {
            return [
                { value: 'name', width: '200px' },
                { value: 'description', width: '400px' },
                {
                    value: 'price',
                    width: '200px',
                    type: 'number',
                    filter: 'formatPrice'
                },
                {
                    value: 'tags',
                    filterFieldName: 'tags.name',
                    width: '150px',
                    sortable: false,
                    filter: v => v.map(tag => tag.name).join(', ')
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalFetchData() {
            return {
                id: this.shopId
            };
        }
    },

    async created() {
        try {
            this.shop = await this.getShop(this.shopId);
        } catch (err) {
            console.error(err);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getShop: 'shops/show',
            getItems: 'shops/getProducts',
            deleteItem: 'products/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/shops/${this.shopId}/products/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push(`/shops/${this.shopId}/products/add`);
        }
    }
};
</script>
